export default __webpack_public_path__ + "static/media/blue_user.689bba32.svg";